import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import FAQ from '../../components/FAQ'

import '../../styles/faq.css'
import home_bg from '../../assets/estate1.jpg'
import house2 from '../../assets/house2.png'
import { IoBulbOutline, IoDiamondOutline } from 'react-icons/io5'
import { VscRocket } from 'react-icons/vsc'
// import target from '../../assets/target@2x.png'
// import visionary from '../../assets/visionary@2x.png'
// import red_lady from '../../assets/red_lady.png'
// import HomePartners from '../../components/general/homepage/HomePartners'

const About = () => {
	const [faqs, setfaqs] = useState([
		{
			question: '1. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: true,
		},
		{
			question: '2. How do I Launch a project?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",

			open: false,
		},
		{
			question: '3. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: false,
		},
		{
			question: '4. How do I know if I qualify for funding?',
			answer:
				"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
			open: false,
		},
	])

	const toggleFAQ = (index) => {
		setfaqs(
			faqs.map((faq, i) => {
				if (i === index) {
					faq.open = !faq.open
				} else {
					faq.open = false
				}

				return faq
			})
		)
	}

	return (
		<main className='about'>
			<section
				className='section novi-background breadcrumbs-custom bg-image context-dark'
				style={{ backgroundImage: `url(${home_bg})` }}
			>
				<div className='breadcrumbs-custom-inner'>
					<div className='container breadcrumbs-custom-container'>
						<div className='breadcrumbs-custom-main'>
							<h6
								className='breadcrumbs-custom-subtitle title-decorated'
								style={{ color: 'transparent' }}
							>
								About us
							</h6>
							<h2 className='text-uppercase breadcrumbs-custom-title'>
								About us
							</h2>
						</div>
						<ul className='breadcrumbs-custom-path'>
							<li>
								<Link to='/'>Home</Link>
							</li>
							<li className='active'>About us</li>
						</ul>
					</div>
				</div>
			</section>

			<section className='section novi-background section-lg'>
				<div className='container'>
					<div className='row row-50 justify-content-center justify-content-lg-between flex-lg-row-reverse'>
						<div className='col-md-10 col-lg-6 col-xl-5'>
							<h3 className='text-uppercase text-center font-weight-bold wow-outer'>
								<span className='wow slideInDown green_text'>Who We Are</span>
							</h3>

							<p>
								Showel Global Properties Limited was formed to provide
								commercial real estate services such as brokerage, property
								management, property development, and investment. We aim to
								change the real estate market by understanding and meeting our
								clients' property needs and delivering a start to finish results
								to our clients, prospects, and investors. With over 15 years of
								combined experience and integrity as our watchword, Showel
								Global Properties Limited is on course to becoming one of the
								most reliable real estate companies in Nigeria and beyond
							</p>
							<a
								className='button button-lg button-primary btn_showel button-winona'
								href='about-us.html'
							>
								View properties
							</a>
						</div>
						<div className='col-md-10 col-lg-6 col-xl-6'>
							<img
								className='img-responsive'
								src={house2}
								alt=''
								width='100%'
								height='388'
							/>
						</div>
					</div>
				</div>
			</section>

			<section className='py-5 mb-4' style={{ background: '#f5f6fa' }}>
				<div className='container'>
					<div className='row'>
						<div className='col-md-4 col-sm-6'>
							<div className='text-center vision_box'>
								<IoBulbOutline size={50} />
								<h5> OUR VISION </h5>
								<p>
									To become a leading real estate company in Nigeria. A
									household name in the real estate sector, known within and
									outside Nigeria
								</p>
							</div>
						</div>

						<div className='col-md-4 col-sm-6'>
							<div className='text-center'>
								<VscRocket size={50} />
								<h5> OUR MISSION </h5>
								<p>Providing world-class real estate services</p>
							</div>
						</div>

						<div className='col-md-4 col-sm-6'>
							<div className='text-center'>
								<IoDiamondOutline size={50} />
								<h5> OUR VALUES </h5>
								<ul className='' style={{ marginTop: '1.2rem' }}>
									<li> Mutual Respect </li>
									<li> Integrity </li>
									<li> Optimism </li>
									<li> Professionalism </li>
									<li> Transparency </li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className='about_faq'>
				<div className='container'>
					<h3 className='text-uppercase text-center font-weight-bold wow-outer'>
						<span className='wow slideInDown green_text'>F.A.Qs</span>
					</h3>
					<div className='row'>
						<div className='col-lg-12 col-md-12'>
							<div className='faqs'>
								{faqs.map((faq, i) => (
									<FAQ faq={faq} index={i} key={i} toggleFAQ={toggleFAQ} />
								))}
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}

export default About
